var ApiVersion;
(function (ApiVersion) {
    ApiVersion["v1"] = "v1";
    ApiVersion["v2"] = "v2";
    ApiVersion["v3"] = "v3";
})(ApiVersion || (ApiVersion = {}));

export { ApiVersion };
